import { Dispatch, MiddlewareAPI, UnknownAction } from "@reduxjs/toolkit";
import { Animal, State } from "../../state/types";
import { parseUrl } from "components/Signup/flow/utils/parseUrlQuery";
import Router from "next/router";
import { selectAnimalById } from "../../selectors/animals";

export type StepMapParams = State & { animal?: Animal };

export function getStepParams(
  storeApi: MiddlewareAPI<Dispatch<UnknownAction>, State>
): StepMapParams {
  const { animalId } = parseUrl(Router.query);
  const state = storeApi.getState();

  return {
    ...state,
    animal: animalId ? selectAnimalById(state, animalId) : undefined,
  };
}
